import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body } from "./Typography";
import { formatErrorDetail } from "../utils/query.util";

const useStyles = createStyles({
  errorBox: {
    padding: tokens.spacing[4],
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[2],
  },
  subtleText: {
    color: tokens.color.semantic.text.subtle,
  },
});

interface QueryErrorBoxProps {
  message: string;
  error: unknown;
  testId?: string;
}

export const QueryErrorBox: React.FC<QueryErrorBoxProps> = ({ message, error, testId }) => {
  const { classes } = useStyles();
  const detail = formatErrorDetail(error);

  return (
    <div data-testid={testId} className={classes.errorBox}>
      <Body>{message}</Body>
      {detail && (
        <Body size="sm" className={classes.subtleText}>
          {detail}
        </Body>
      )}
    </div>
  );
};
